import React from "react";
import { ButtonProps } from "./props";

const Button = ({ label, onClick, theme, size, ...props }: ButtonProps) => {
  const onClickWithPreventDefault = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    return onClick?.(event);
  };

  const getClassName = () => {
    return `vcl-button vcl-button-${theme ?? "primary"} vcl-button-size-${
      size ?? "large"
    }`;
  };

  return (
    <button
      onClick={onClickWithPreventDefault}
      className={getClassName()}
      {...props}
    >
      {label}
    </button>
  );
};

export default Button;
